module.exports = __webpack_public_path__ + "static/media/stage4.69e00cf7.svg";